import {useState,useRef,useEffect} from 'react';
export default function useFilterOptions(loaders){
 const [state,setState]=useState({});const pending=useRef({}),alive=useRef(true);
 useEffect(()=>{alive.current=true;return()=>{alive.current=false;};},[]);
 const load=(id,force=false)=>{
  if(!loaders[id]||pending.current[id]||(!force&&state[id]?.options))return;
  pending.current[id]=true;setState(s=>({...s,[id]:{loading:true}}));
  Promise.resolve().then(loaders[id]).then(options=>{if(alive.current)setState(s=>({...s,[id]:{options}}));}).catch(()=>{if(alive.current)setState(s=>({...s,[id]:{error:true}}));}).finally(()=>{pending.current[id]=false;});
 };
 const props=id=>({...state[id],retry:()=>load(id,true)});
 return {load,props};
}
